<template lang="pug">
  ProgramSettingsFormWrapper#general-settings(
    :form-data="formData"
    :keys-to-reset="keysToReset"
    :disable-save.sync="disableSave"
    title=""
  )
    WtTile(child :col="12").has-background-light
      .is-flex.mb-4
        WtTitle(card-title).mr-5.mt-1.mb-1  Organizations
        WtRadioQuestionInput
          template(v-slot:radioOne)
            BRadio(
              v-model="organizationsOn"
              :native-value="1"
              @input="disableSave = false"
            ) On
          template(v-slot:radioTwo)
            BRadio(
              v-model="organizationsOn"
              :native-value="0"
              @input="disableSave = false"
            ) Off
      span.is-size-6 Organizations are a way to organize program members to match the structure of your organization.
      WtTitle(card-title).mr-5.mt-5.mb-1  Organization Name
      span.is-size-6 Change the name of how Organization tools are labeled in your program (Location, Branch, Shift, etc.)
      WtTile(child :col="6" child-class="no-padding")
        BInput.mt-3(
          name="organizationsName"
          v-model="organizationsName"
          @input="disableSave = false"
        )

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProgramSettingsFormWrapper from "@@/ProgramSettingsAdmin/ProgramSettingsFormWrapper";
import ProgramSettingsFormControls from "@@/ProgramSettingsAdmin/ProgramSettingsFormControls";
import WtRadioQuestionInput from "@@/WtRadioQuestionInput/WtRadioQuestionInput";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";

export default {
  name: "GeneralSettings",

  components: {
    ProgramSettingsFormWrapper,
    ProgramSettingsFormControls,
    WtRadioQuestionInput,
    WtTitle,
    WtTile
  },

  data() {
    return {
      disableSave: true
    };
  },

  computed: {
    ...mapGetters("program", ["programSettingsCopy", "programLoaded"]),

    formData() {
      return {
        organizationsOn: this.organizationsOn,
        organizationsName: this.organizationsName
      };
    },

    keysToReset() {
      return ["organizationsOn", "organizationsName"];
    },

    organizationsOn: {
      set(organizationsOn) {
        this.updateProgramSettingsCopy({
          key: "organizationsOn",
          value: organizationsOn
        });
      },
      get() {
        return Number(this.programSettingsCopy.organizationsOn);
      }
    },

    organizationsName: {
      set(organizationsName) {
        this.updateProgramSettingsCopy({
          key: "organizationsName",
          value: organizationsName
        });
      },
      get() {
        return this.programSettingsCopy.organizationsName;
      }
    }
  },

  methods: {
    ...mapActions("program", ["updateProgramSettingsCopy"])
  }
};
</script>

<style lang="sass" scoped></style>
